import React, { useState } from 'react';
import { MenuIcon, XIcon, MoonStarIcon, PhoneIcon } from 'lucide-react';
import { business, getWhatsAppLink } from '../data/business';
import { WhatsAppButton } from './WhatsAppButton';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
const navLinks = [{
  href: '#inicio',
  label: 'Inicio'
}, {
  href: '#sobre-nosotros',
  label: 'Nosotros'
}, {
  href: '#por-que-elegirnos',
  label: 'Por qué elegirnos'
}, {
  href: '#servicios',
  label: 'Servicios'
}, {
  href: '#testimonios',
  label: 'Testimonios'
}, {
  href: '#contacto',
  label: 'Contacto'
}];
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-40 w-full border-b border-gold-500/30 bg-emerald-800/95 backdrop-blur" data-id="element-128" data-mp="14xq12ldhh1e1">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 lg:px-8" data-id="element-129" data-mp="zzol49bcti6s">
        <a href="#inicio" className="flex items-center gap-3" data-id="element-130" data-mp="2gdohjaazqppa">
          <MoonStarIcon className="h-6 w-6 text-gold-400" aria-hidden="true" data-id="element-131" data-mp="2bbpczx3ilmqr" />
          <span className="flex flex-col leading-none" data-id="element-132" data-mp="29klk9a8j95xx">
            <span className="font-display text-xl font-semibold tracking-wide text-ivory-50 sm:text-2xl" data-id="element-133" data-mp="29m6eeyqxqmv9">
              {business.brand}
            </span>
            <span className="mt-1 text-[10px] uppercase tracking-[0.22em] text-sage-200" data-id="element-134" data-mp="2jj1cxhn7kn9j">
              {business.legalName}
            </span>
          </span>
        </a>

        <nav aria-label="Navegación principal" className="hidden lg:block" data-id="element-135" data-mp="1qtueeinr7xoa">
          <ul className="flex items-center gap-7" data-id="element-136" data-mp="1qrhptmnhqp29">
            {navLinks.map(link => <li key={link.href} data-id="element-137" data-mp="1vq2ohhn3h0ol">
                <a href={link.href} className="text-xs font-medium uppercase tracking-[0.14em] text-ivory-100 transition-colors hover:text-gold-300" data-id="element-138" data-mp="20qytxzn3guw4">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="hidden items-center gap-3 lg:flex" data-id="element-139" data-mp="1d0w1vjj6joxi">
          <a href={`tel:${business.phoneHref}`} className="inline-flex items-center gap-2 rounded-sm border border-ivory-200/50 px-5 py-3 text-sm font-semibold uppercase tracking-[0.12em] text-ivory-100 transition-colors hover:border-gold-400 hover:text-gold-300" data-id="element-140" data-mp="151858dx2dc08">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-141" data-mp="19ry9toxo1atv" />
            {business.phone}
          </a>
          <WhatsAppButton label="WhatsApp" variant="onEmerald" className="wa-pulse px-5 py-3" data-id="element-142" data-mp="m23yjbszvubq" />
        </div>

        <div className="flex items-center gap-2 lg:hidden" data-id="element-143" data-mp="h53t933yyvlo">
          <a href={`tel:${business.phoneHref}`} aria-label={`Llamar al ${business.phone}`} className="rounded-sm border border-ivory-200/50 p-2.5 text-ivory-100" data-id="element-144" data-mp="w0tjjdg6tuw7">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-145" data-mp="27enlyrm313tg" />
          </a>
          <a href={getWhatsAppLink() ?? '#contacto'} target="_blank" rel="noopener noreferrer" aria-label="Escribir vía WhatsApp" className="wa-pulse rounded-sm bg-gold-400 p-2.5 text-graphite-900" data-id="element-146" data-mp="22h58qp1182fn">
            <WhatsAppIcon className="h-5 w-5" data-id="element-147" data-mp="2ewv87i0aspkf" />
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="menu-movil" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="rounded-sm border border-ivory-200/40 p-2.5 text-ivory-100" data-id="element-148" data-mp="210rpolyse5ns">
            {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-149" data-mp="2jyasv8ykcu2a" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-150" data-mp="2jw85kwospf19" />}
          </button>
        </div>
      </div>

      {open && <div className="border-t border-gold-400/30 bg-emerald-900 lg:hidden" id="menu-movil" data-id="element-151" data-mp="3boyq49x49fao">
          <nav aria-label="Navegación móvil" className="mx-auto max-w-6xl px-5 py-4" data-id="element-152" data-mp="3ggqk6ufhe35k">
            <ul className="flex flex-col divide-y divide-ivory-200/15" data-id="element-153" data-mp="1srvn6zxeqy6u">
              {navLinks.map(link => <li key={link.href} data-id="element-154" data-mp="1ns9cax51xu17">
                  <a href={link.href} onClick={() => setOpen(false)} className="block py-3.5 text-sm uppercase tracking-[0.12em] text-ivory-100" data-id="element-155" data-mp="1nr7qpyqetp58">
                    {link.label}
                  </a>
                </li>)}
            </ul>
            <div className="mt-5 flex flex-col gap-3" data-id="element-156" data-mp="2bk7qbovvy3i1">
              <WhatsAppButton variant="onEmerald" className="w-full" data-id="element-157" data-mp="26klbxc4bmh7n" />
              <a href={`tel:${business.phoneHref}`} className="inline-flex w-full items-center justify-center gap-2 rounded-sm border border-ivory-200/50 px-6 py-3.5 text-sm font-semibold uppercase tracking-[0.12em] text-ivory-100" data-id="element-158" data-mp="21s1xye1q1k2b">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-159" data-mp="2pi60ei36bdrq" />
                Llamar {business.phone}
              </a>
            </div>
          </nav>
        </div>}
    </header>;
}